const CORES = [
  ['verde', 'Verde'],
  ['vermelho', 'Vermelho'],
  ['azul', 'Azul'],
];

const DestaqueSchema = () => ({
  title: 'AgSUS Destaque',
  fieldsets: [
    {
      id: 'default',
      title: 'Conteúdo',
      fields: [
        'composicao',
        'etiqueta',
        'corEtiqueta',
        'imagem',
        'alt',
        'credito',
      ],
    },
    {
      id: 'aparencia',
      title: 'Aparência',
      fields: [
        'fundo',
        'ladoImagem',
        'ajusteImagem',
        'posicaoImagem',
        'corPainel',
      ],
    },
    {
      id: 'avancado',
      title: 'Título e âncora',
      fields: ['nivel', 'ancora'],
    },
  ],
  properties: {
    composicao: {
      title: 'Composição',
      description:
        'Foto em cima: cartão com a foto no alto. Foto ao lado: foto alta e cartão encostado. Painel de cor: imagem de um lado e texto branco sobre cor do outro.',
      choices: [
        ['topo', 'Foto em cima'],
        ['lado', 'Foto ao lado'],
        ['painel', 'Painel de cor'],
      ],
      default: 'topo',
    },
    etiqueta: {
      title: 'Etiqueta',
      description:
        'Título da seção, mostrado em caixa alta sobre a faixa colorida. Vale como intertítulo da página e entra na barra de âncoras. Vazio: sem título.',
    },
    corEtiqueta: {
      title: 'Cor da etiqueta',
      choices: CORES,
      default: 'verde',
    },
    imagem: {
      title: 'Imagem',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: false,
      selectableTypes: ['Image'],
    },
    alt: {
      title: 'Texto alternativo',
      description:
        'Descreva a imagem para quem não a vê. Deixe vazio só se a imagem for decorativa.',
    },
    credito: {
      title: 'Crédito ou legenda',
      description: 'Ex.: Foto: Nome/AgSUS',
    },
    fundo: {
      title: 'Fundo',
      description:
        'Vazio: faixa azul na foto em cima e na foto ao lado; sem faixa no painel de cor.',
      choices: [
        ['azul', 'Faixa azul com padronagem'],
        ['nenhum', 'Sem faixa'],
      ],
    },
    ladoImagem: {
      title: 'Lado da imagem',
      description: 'Na foto ao lado e no painel de cor.',
      choices: [
        ['esquerda', 'Esquerda'],
        ['direita', 'Direita'],
      ],
      default: 'esquerda',
    },
    ajusteImagem: {
      title: 'Ajuste da imagem',
      description:
        'Vazio: a foto preenche o espaço, e no painel de cor a imagem aparece inteira.',
      choices: [
        ['preencher', 'Preencher o espaço (foto)'],
        ['inteira', 'Inteira, sem cortar (marca ou ilustração)'],
      ],
    },
    posicaoImagem: {
      title: 'Enquadramento da foto',
      description:
        'Que parte da foto fica à vista quando ela é recortada para caber no espaço. Ex.: Esquerda, se o assunto está à esquerda da foto.',
      choices: [
        ['centro', 'Centro'],
        ['esquerda', 'Esquerda'],
        ['direita', 'Direita'],
        ['alto', 'Alto'],
        ['baixo', 'Baixo'],
      ],
      default: 'centro',
    },
    corPainel: {
      title: 'Cor do painel',
      description: 'No painel de cor.',
      choices: CORES,
      default: 'verde',
    },
    nivel: {
      title: 'Nível do título',
      choices: [
        ['h2', 'Intertítulo (H2)'],
        ['h3', 'Subtítulo (H3)'],
      ],
      default: 'h2',
    },
    ancora: {
      title: 'Âncora',
      description:
        'Endereço da seção na barra de âncoras, sem #. Vazio: gerado da etiqueta, como nos intertítulos.',
    },
  },
  required: [],
});

export default DestaqueSchema;
